import * as React from "react";
import { Time } from "../shared/Time";
import { TickerMatch } from "../models";
import { BeachTickerMatch } from "../beach/model";

interface Props {
  match: TickerMatch | BeachTickerMatch
}

export const MatchDate = React.memo((props: Props) => {
  const { match } = props
  return (
    <div className="Match-date">
      <div>{match.formattedDate}</div>
      <Time formattedTime={match.formattedTime} />
    </div>
  )
})
